/**
 * Created by idea on 27/03/2017.
 */
import { Component, Input } from '@angular/core';
import { Owner } from '../models/Owner';
import { Http } from '@angular/http';

@Component({
  selector: 'img-fb',
  template: `<img
    style="border-radius:50%; display:inline-block;"
    [src]="src"
    [alt]="alt"
    [title]="title"
    [class]="class"
    width="45px"
  />`,
})
export class ImageFbComponent {
  public _src: String = '';
  @Input()
  id: string;

  @Input()
  alt: string;

  @Input()
  title: string;

  @Input()
  class: string;

  @Input()
  width: number;

  @Input()
  height: number;

  get src() {
    this._src = 'https://graph.facebook.com/' + this.id + '/picture?type=square';
    return this._src;
  }
  constructor(private http: Http) {}
}



// WEBPACK FOOTER //
// ./src/app/common/helper/imageFb.component.ts